const themes = {
  brand: {
    color: '#c93e4e'
  },
  info: {
    color: '#40acf4'
  }
};

export default themes;



// WEBPACK FOOTER //
// ./src/utils/themes.js